// CSS from /static/css
import './css/style.scss'

// CSS from node_modules
import '@mdi/font/css/materialdesignicons.min.css'
import 'cropperjs/dist/cropper.css'
import 'bootstrap-multiselect/dist/css/bootstrap-multiselect.css'
import 'notyf/notyf.min.css'

// First jQuery
import $ from 'jquery';
window.jQuery = window.jquery = window.$ = $;

// Then Knockout
import ko from 'knockout';
window.ko = ko;

// import 3rd party, like bootstrap
import 'bootstrap';
import 'bootstrap-multiselect';
import 'pagerjs';
import { Notyf } from 'notyf';

// Create a global notyf instance
window.notyf = new Notyf();

// Custom Knockout stuff
import 'shared/ko/bindings';
import 'shared/ko/extenders';
import 'shared/ko/fn';

document.addEventListener('DOMContentLoaded', async () => {
    try {
        // Make sure jQuery and Knockout are available before initializing SCViewModel
        if (window.ko && window.$) {
            $.ajaxSetup({ cache: false });

            const scvm = new SCViewModel({});
            window.scvm = scvm;

            scvm.check_login_status().then(function () {
                if (!scvm.user_logged_in()) {
                    scvm.maybe_login_with_url_key();
                }
            });

            if (window.pager && typeof window.pager.start === 'function') {
                console.log('Trying to start pager!');
                window.pager.extendWithPage(window.scvm);
                ko.applyBindings(window.scvm);
                window.pager.start();
            } else {
                console.error('Pager start method not found:', window.pager);
            }
        }
    } catch (error) {
        console.error("Error loading plugins:", error);
    }
});

// UUID helper function
window.uuidv4 = () => crypto.randomUUID();
// Import custom components
import './components/extra-notes'
import './components/artist-recommendation-text'
import './components/location-searach-admin'
import './components/table-header-cell'
import './components/artist-info-modal'
import './components/person-info-modal'
import './components/details-modal'
import './components/email-composer'
import { CSVPrinter } from './classes/CSVPrinter'
import { WebappSession } from './classes/Webappsession'
import { AllPeopleViewModel } from './viewmodels/admin/allpeoplevm'
import { AllArtistsViewModel } from './viewmodels/admin/allartistsvm'
import { AllHostsViewModel } from './viewmodels/admin/allhostsvm'
import { AllEmailsViewModel } from './viewmodels/admin/allemailsvm'
import { AdReportViewModel } from './viewmodels/admin/adreportvm'
import { AllPastEventsViewModel } from './viewmodels/admin/allpasteventsvm'
import { AllPayinsViewModel } from './viewmodels/admin/allpayinsvm'
import { AllUpcomingEventsViewModel } from './viewmodels/admin/allupcomingeventsvm'
import { ConversionViewModel } from './viewmodels/admin/conversionvm'
import { MatchmakingViewModel } from './viewmodels/admin/matchmakingvm'
import { AllSonggefluesterViewModel } from './viewmodels/admin/allsonggefluestervm'
import { NewInvitesConversionViewModel } from './viewmodels/admin/newinvitesconversionvm'
import { AllInvoicesViewModel } from './viewmodels/admin/allinvoicesvm';
import { ExternalBalanceViewModel } from './viewmodels/admin/externalbalancevm'
import { ExpensesViewModel } from './viewmodels/admin/expensesvm'
import { GiftCardViewModel } from './viewmodels/admin/giftcardvm'
import { ProjectsViewModel } from './viewmodels/admin/accounting/projects'
import { KPIViewModel } from './viewmodels/admin/kpivm'
import { ImageUploaderViewModel } from './viewmodels/admin/tools/image-uploader'
import { ImageLibraryViewModel } from './viewmodels/admin/tools/image-library'
import { DiscountCodeViewModel } from './viewmodels/admin/discountcodesvm'
import { RefundCodeViewModel } from './viewmodels/admin/tools/refundcodesvm'
import { CurrencyViewModel } from './viewmodels/admin/currencyvm'
import { InstagramViewModel } from './viewmodels/admin/instagramvm'
import { LeaderboardViewModel } from './viewmodels/admin/leaderboardvm'
import { ArtistBookingStatsViewModel } from './viewmodels/admin/artistbookingstatsvm'
import { TextFilterViewModel } from './viewmodels/admin/tools/text-filter'
import { EventCallsViewModel } from './viewmodels/admin/alleventcallsvm'
import { VorwerkGewinnspielViewModel } from './viewmodels/admin/vorwerkgewinnspielvm'


function SCViewModel(data) {
    var self = this;
    self.type = "SCViewModel"

    data.rootvm = this;
    self.web_host = window.web_host;
    self.frontend_web_host = window.frontend_web_host;
    self.image_path_prefix = window.image_path_prefix;

    self.is_busy = ko.observable(false);
    self.syslog = ko.observable("");
    self.csvprint = new CSVPrinter({ rootvm: self });

    self.click_on_enter = function (selector_id) {
        if ($('#' + selector_id).attr('disabled') != 'disabled') {
            $('#' + selector_id)[0].click();
        }
    };

    self.webapp_session = ko.observable(
        new WebappSession({ rootvm: self }));


    self.check_login_status = function () {
        return self.webapp_session().get_session_status();
    };

    self.send_to_login_screen_if_not_logged_in = function () {
        self.check_login_status().then(function () {

            if (!self.user_logged_in()) {
                pager.navigate('login');
                notyf.error("You have to log in first!");
            }
        });

    };

    self.user_logged_in = ko.computed(
        () => (self.webapp_session().person_uuid())
    );

    self.show_accounting_tab = ko.pureComputed(
        () => (self.user_logged_in() && ['intern', 'admin'].indexOf(self.webapp_session().user().group_title()) >= 0)
    );

    self.show_kpi_tab = ko.pureComputed(
        () => (self.user_logged_in() && ['admin', 'investor'].indexOf(self.webapp_session().user().group_title()) >= 0)
    );

    self.show_all_kpi = ko.pureComputed(
        () => (self.user_logged_in() && ['admin'].indexOf(self.webapp_session().user().group_title()) >= 0)
    );

    self.show_community_tab = ko.pureComputed(
        () => (self.user_logged_in() && ['intern', 'admin'].indexOf(self.webapp_session().user().group_title()) >= 0)
    );

    self.show_concerts_tab = ko.pureComputed(
        () => (self.user_logged_in() && ['intern', 'admin'].indexOf(self.webapp_session().user().group_title()) >= 0)
    );

    self.show_tools_tab = ko.pureComputed(
        () => (self.user_logged_in() && ['intern', 'admin'].indexOf(self.webapp_session().user().group_title()) >= 0)
    );

    self.show_arosa_tab = ko.pureComputed(
        () => (false && self.user_logged_in() && ['intern', 'admin', 'external'].indexOf(self.webapp_session().user().group_title()) >= 0)
    );

    self.show_arosa_coordination = ko.pureComputed(
        () => (false && self.user_logged_in() && ['admin', 'external'].indexOf(self.webapp_session().user().group_title()) >= 0)
    );

    // Community
    self.allpeoplevm = new AllPeopleViewModel(data);
    self.allartistsvm = new AllArtistsViewModel(data);
    self.allhostsvm = new AllHostsViewModel(data);
    self.allemailsvm = new AllEmailsViewModel(data);
    self.adreportvm = new AdReportViewModel(data);
    self.vorwerkgewinnspielvm = new VorwerkGewinnspielViewModel(data);
    // Concerts
    self.allpasteventsvm = new AllPastEventsViewModel(data);
    self.allpayinsvm = new AllPayinsViewModel(data);
    self.allupcomingeventsvm = new AllUpcomingEventsViewModel(data);
    self.conversionvm = new ConversionViewModel(data);
    self.matchmakingvm = new MatchmakingViewModel(data);
    self.songgefluestervm = new AllSonggefluesterViewModel(data);
    self.newinvitesvm = new NewInvitesConversionViewModel(data);
    self.eventcallsvm = new EventCallsViewModel(data);
    // Accounting
    self.allinvoicesvm = new AllInvoicesViewModel(data);
    self.externalbalancevm = new ExternalBalanceViewModel(data);
    self.expensesvm = new ExpensesViewModel(data);
    self.giftcardvm = new GiftCardViewModel(data); // also used in Tools/GiftCardList
    self.accountingprojectsvm = new ProjectsViewModel(data);
    // KPIs
    self.kpvm = new KPIViewModel(data);
    // Tools
    self.toolsimageuploadervm = new ImageUploaderViewModel(data);
    self.toolsimagelibraryvm = new ImageLibraryViewModel(data);
    self.discountcodesvm = new DiscountCodeViewModel(data);
    self.refundcodesvm = new RefundCodeViewModel(data);
    self.currencyvm = new CurrencyViewModel(data);
    self.instagramvm = new InstagramViewModel(data);
    self.leaderboardvm = new LeaderboardViewModel(data);
    self.artistbookingstatsvm = new ArtistBookingStatsViewModel(data);
    self.textfiltervm = new TextFilterViewModel(data);

    self.maybe_login_with_url_key = function () {
        var urlParams = new URLSearchParams(window.location.search);
        var key = urlParams.get('key');
        var person_uuid = urlParams.get('person_uuid');
        if (key && person_uuid) {
            return self.webapp_session().user().sign_in_with_key(key, person_uuid)
        }
    }
}
